import React from 'react';
import * as styles from './styles.scss';

interface BackButtonProps {
  environment: 'dark' | 'light';
  text?: string;
  href?: string;
  onClick?: () => void;
}

const BackButton = ({ environment, text, href, onClick }: BackButtonProps) => {
  if (!href && !onClick) {
    return null;
  }

  return (
    <a href={href} onClick={onClick} className={styles.backIconContainer}>
      <svg className={styles.backIcon} xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
        <path
          fill={environment === 'dark' ? 'rgba(255, 255, 255, 1)' : 'rgba(0, 0, 0, 1)'}
          fillRule="evenodd"
          d="M17.3287576,26 L23.6016301,32.2728725 C23.9951004,32.6663428 24.0011232,33.2982615 23.607838,33.6915467 L22.8993918,34.3999929 C22.50935,34.7900348 21.8757052,34.7887727 21.4807175,34.393785 L13.0458629,25.9589305 C13.0304581,25.9452964 13.015364,25.9311006 13.000606,25.9163426 L12.2921598,25.2078964 C12.117633,25.0333696 12.021452,24.8100692 12.0038339,24.5812003 C11.9798094,24.2991573 12.0752548,24.0096659 12.2921598,23.7927609 L13.000606,23.0843147 C13.0152764,23.0696443 13.0302915,23.0555274 13.0456255,23.0419643 L21.4807175,14.6068723 C21.8741879,14.2134019 22.5061065,14.2073792 22.8993918,14.6006644 L23.607838,15.3091106 C23.9978798,15.6991524 23.9966178,16.3327972 23.6016301,16.7277849 L17.329415,23 L32.0066023,23 C32.5552407,23 33,23.4426603 33,23.9989566 L33,25.0010434 C33,25.5527519 32.5550537,26 32.0066023,26 L17.3287576,26 Z"
          transform="translate(-12 -14)"
        />
      </svg>
      {text && <span className={styles.textContainer}>{text}</span>}
    </a>
  );
};

export default BackButton;
